<section class="feedback section" id="feedback">
  <div class="shell-container reveal" appRevealOnScroll="80ms">
    <div class="feedback__header">
      <div class="badge">Customer Feedback</div>
      <h2>Real words from pet parents who trust us.</h2>
      <p class="feedback__lede">
        Calm visits, consistent results, and gentle care shared by the families who bring us their dogs and
        cats.
      </p>
    </div>

    <div class="feedback__grid">
      <article class="feedback__card" *ngFor="let t of testimonials">
        <div class="feedback__stars" aria-label="{{ t.rating }} out of 5 stars">
          <span *ngFor="let s of [1,2,3,4,5]" class="feedback__star" [class.is-filled]="s <= t.rating">
            ★
          </span>
        </div>
        <p class="feedback__quote">“{{ t.quote }}”</p>
        <div class="feedback__meta">
          <span class="feedback__name">{{ t.name }}</span>
          <span class="feedback__pet">{{ t.pet }}</span>
        </div>
      </article>
    </div>
  </div>
</section>
